// 部门(组织机构)管理
import request from '@/router/axios';

let urlPrefix = '/api/system/recommended';

/**
 * 根据机构id获取机构的推荐课程
 * @param {*} id 
 */
export const getDeptRecommend = id => {
    return request(`${urlPrefix}/select/${id}`)
}

export const getRecommendList = (page, limit, params) => {
    return request(`${urlPrefix}/queryAllRec`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}


export const setRecommendLesson = (uid) => {
    return request(`${urlPrefix}/set/${uid}`, null, 'put');
}

export const removeRecommend = uid => {
    return request(`${urlPrefix}/remove/${uid}`, null, 'delete');
};

export const moveIndex = (uid , type) => {
    return request(`${urlPrefix}/moveIndex/${uid}/${type}`, {}, 'post')
}